/*
This filter translates an engagement restriction area ID to a user facing string label.
 */
angular.module('rightPaneModule')
.filter('EngagementRestrictionLabelFilter', [function () {
    return function (id) {
        var label;
        switch (id) {
            case 'arcade_restricted':
                label = 'Arcade';
                break;
            case 'my_house_restricted':
                label = 'My House';
                break;
            case 'collections_restricted':
                label = 'Collections';
                break;
            case 'personalization_restricted':
                label = 'Personalization';
                break;
            case 'school_hours':
                label = 'School Hours';
                break;
            default:
                label = 'restricted';
                console.error("No restriction mapped for code: " + id);
        }
        return label;
    };
}]);
